export default [
  {
    path: "mission",
    name: "mission",
    component: () => import("@/views/mission/index.vue"),
  }
];
